import React from 'react';
import { Grid, Hidden } from '@material-ui/core';
import { InfoPerksContext } from '../../../contexts';
import { PageSectionPB } from '../../PricingBenefits/shared';
import { PerkOptions, PerkSpend, SpendTracker } from './components';
export var PerkProgress = React.memo(function () {
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    return (React.createElement(PageSectionPB, { title: "Perk Progress", classes: "" },
        React.createElement(Grid, { container: true, alignItems: "stretch", className: "PerksPage__PerkProgress", spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12, md: 7, xl: 8 },
                React.createElement(Hidden, { mdDown: true },
                    React.createElement(PerkSpend, null),
                    React.createElement(SpendTracker, null)),
                React.createElement(Hidden, { lgUp: true },
                    React.createElement(PerkSpend, { isMobile: true }),
                    React.createElement(SpendTracker, { isMobile: true }))),
            React.createElement(Grid, { item: true, xs: 12, md: 5, xl: 4 },
                React.createElement(Hidden, { smDown: true }, perksInfo && React.createElement(PerkOptions, { isMobile: false, PerkInfo: perksInfo })),
                React.createElement(Hidden, { mdUp: true }, perksInfo && React.createElement(PerkOptions, { isMobile: true, PerkInfo: perksInfo }))))));
});
